export const isFn = (unkFn: any): unkFn is Function => {
	return typeof unkFn === "function";
};

export const isObj = (unkObj: any): unkObj is object => {
	return Object.prototype.toString.call(unkObj) === "[object Object]";
};

export const isNumber = (x: any) => typeof x === "number";
